export function decodeNull(): [null, number] {
  return [null, 1];
}
